import type { PartnerFilters } from '@/features/partners';

export const masterKeys = {
  all: ['masters'] as const,
  lists: () => [...masterKeys.all, 'list'] as const,
  list: (filters: MaybeRef<PartnerFilters> = {}) =>
    [...masterKeys.lists(), filters] as const,
  featuredList: () => [...masterKeys.list(), 'featured'] as const,
  details: () => [...masterKeys.all, 'detail'] as const,
  detail: (idOrSlug: MaybeRef<number | string>) =>
    [...masterKeys.all, 'detail', idOrSlug] as const,
  workPlaces: (masterId: MaybeRef<number>) =>
    [...masterKeys.all, 'workPlaces', masterId] as const,
  workPlaceInfos: (masterId: MaybeRef<number>) =>
    [...masterKeys.all, 'workPlaceInfos', masterId] as const,
  appointablePeriods: (masterId: MaybeRef<number>, date: MaybeRef<Date>) =>
    [...masterKeys.all, 'appointablePeriods', masterId, date] as const,
  experienceRecords: (id: MaybeRef<number>) =>
    [...masterKeys.all, 'experienceRecords', id] as const,
  search: (query: MaybeRef<string>) =>
    [...masterKeys.all, 'search', query] as const,
  mapData: (filters: MaybeRef<PartnerFilters>) =>
    [...masterKeys.all, 'map-data', filters] as const,
};

export const comapnyMasterKeys = {
  all: ['company-masters'] as const,
  lists: () => [...comapnyMasterKeys.all, 'list'] as const,
  list: (companyId: MaybeRef<number>) =>
    [...comapnyMasterKeys.lists(), companyId] as const,
};

export const masterReviewKeys = {
  all: ['mastersReviews'] as const,
  lists: () => [...masterReviewKeys.all, 'list'] as const,
  list: (masterId: MaybeRef<number>) => [...masterReviewKeys.lists(), masterId],
  details: () => [...masterReviewKeys.all, 'detail'] as const,
  detail: (id: MaybeRef<number>) =>
    [...masterReviewKeys.all, 'detail', id] as const,
};
